import {Button, makeStyles, SvgIcon} from "@material-ui/core";
import {Link as RouterLink} from "react-router-dom";
import {PlusCircle as PlusCircleIcon} from "react-feather";
import React from "react";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
	root: {},
	action: {
		marginBottom: theme.spacing(1)
	}
}));

export const CreateButton = ({url}) => {

	const { t } = useTranslation();
	const classes = useStyles();

    return (<Button
					color="secondary"
					variant="contained"
					className={classes.action}
					component={RouterLink}
					to={url}
					startIcon={
						<SvgIcon fontSize="small">
							<PlusCircleIcon />
						</SvgIcon>
					}
				>
                    {t('Create')}
				</Button>);
}